import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl, getConfig } from '../../../../../serverUrl';
import { handleUnauthorized } from '../../auth401.ts';

// Get authorization config
const getConfigData = () => getConfig();

export const tenantSlice = createApi({
    reducerPath: 'TenantApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    tagTypes: ['Tenant'],
    endpoints: (builder) => ({
        generateKRAEtimsInvoice: builder.mutation({
            queryFn: async (bodyCredentials) => {
                try {
                    const response = await fetch(`${baseUrl}/tenant/generate_kra_etims_invoice/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...getConfigData().headers,
                        },
                        body: JSON.stringify(bodyCredentials),
                    });
                    if (response.status === 401) {
                        handleUnauthorized();
                        return { error: { status: 401, data: 'Unauthorized' } };
                    }
                    const data = await response.json();
                    return { data };
                } catch (error) {
                    return { error: { status: 500, data: "Failed to fetch Tenant data" } };
                }
            },
            invalidatesTags: ['Tenant'],
        }),
        changeTenantDetails: builder.mutation({
            queryFn: async ({ tenantId, bodyCredentials }) => {
                try {
                    const response = await fetch(`${baseUrl}/tenant/tenant/${tenantId}/`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            ...getConfigData().headers,
                        },
                        body: JSON.stringify(bodyCredentials),
                    });
                    if (response.status === 401) {
                        handleUnauthorized();
                        return { error: { status: 401, data: 'Unauthorized' } };
                    }
                    const data = await response.json();
                    return { data };
                } catch (error) {
                    return { error: { status: 500, data: "Failed to fetch Tenant data" } };
                }
            },
            invalidatesTags: ['Tenant'],
        }),
    }),
});

// Export hooks for usage in components
export const { useGenerateKRAEtimsInvoiceMutation, useChangeTenantDetailsMutation } = tenantSlice;
